import { ref } from 'vue';

const message = ref('');

const useMessages = () => {
    const showMessage = (msg) => {
        message.value = msg;
    };

    const hideMessage = () => {
        message.value = '';
    };

    return { message, showMessage, hideMessage };
};

export default useMessages;
